import RecommendItem from '../../src/legacy/RecommendItem';
export default RecommendItem;
